module.exports = __webpack_public_path__ + "static/media/insta-03.7266dc21.jpg";